import { CourseCertificateEnum } from '../training.interface';

export enum ECourseTabSectionKey {
  Introduction = 'Course_Introduction',
  HighlightCourses = 'Course_HighlightCourses',
  BusinessCourses = 'Course_BusinessCourses',
  EliteTeachers = 'Course_EliteTeachers',
}

export interface ICourseTabIntroductionSection {
  backgroundImage: string;
  title: string;
}

export interface ICourseTabEliteTeachersSection {
  fullName: string;
  academicDegree: string;
  descriptionContent: string;
  image: string;
}

export type TEnterpriseProfileCourseTabSectionElements =
  | ICourseTabIntroductionSection
  | ICourseTabEliteTeachersSection;

export type TEnterpriseProfileCourseTabSection = {
  sectionName: string;
  sectionKey: ECourseTabSectionKey;
  elements?: TEnterpriseProfileCourseTabSectionElements;
  isActive: boolean;
}[];

export interface ICourseEnterprise {
  id: string;
  title: string;
  description: string;
  thumbnail: string | null;
  certificateShortName: CourseCertificateEnum | null;
  folderId: string;
  lessonCount: number;
  /** TMS ID */
  userId: string;
  email: string;
  fullName: string;
  academicRank: string | null;
  /** Qbank ID */
  ownerId: number;
  coursePrice: null | number;
  createdOn: string;
  memberCount: number;
  memberAvatars: Array<string | null>;
}

export type TRecommendCourses = {
  id: string;
  thumbnail: string;
  title: string;
  description: string;
  certificateShortName: CourseCertificateEnum;
  memberCount: number;
  memberAvatars: string[];
  folderId: string;
}[];

export type THighlightCourses = {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  certificateShortName: CourseCertificateEnum;
  folderId: string;
  memberCount: number;
  coursePrice: number;
  recentMembers: {
    userId: string;
    email: string;
    avatar: string;
  }[];
}[];
